var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 11.869c1.073-.399 1.633-1.166 1.633-2.487 0-1.32-1.113-2.484-2.503-2.487-1.468-.002-2.575 1.162-2.557 2.487.017 1.326.65 2.208 1.661 2.527l-1.792 4.41c-2.4-.622-4.839-3.452-4.839-6.937A7.455 7.455 0 0 1 9.016 1.91c4.157 0 7.527 3.346 7.527 7.473 0 3.54-2.417 6.33-4.867 6.949L9.94 11.869Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSource);
export default __webpack_public_path__ + "f3e222fdf9c0aa22b2f73c5bcdbcd7e3.svg";
export { ForwardRef as ReactComponent };